import { createStore, compose, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import { RegisterProps, QuestionsProps } from "../typings/register";
import { MemberProps, ProfileMemberData } from "../typings/member";
import { AppSettingsState } from "./../typings/app";
import { MoodProps } from "../typings/mood";
import { HomeDataState } from "../typings/carpet";
import thunk from "redux-thunk";
import signup from "./signup";
import signupQuestions from "./signupQuestions";
import member from "./member";
import app from "./app";
import mood from "./mood";
import carpet from "./carpet";
import profileMember from "./profileMember";
import searchUsers from "./searchUsers";
import { SearchUsersProps } from "../typings/searchUsers";

export interface RootState {
  app: AppSettingsState;
  signup: RegisterProps;
  signupQuestions: QuestionsProps;
  member: MemberProps;
  mood: MoodProps[];
  carpet: HomeDataState;
  profileMember: ProfileMemberData;
  searchUsers: SearchUsersProps;
}

const combinedReducers = combineReducers({
  searchUsers,
  signup,
  signupQuestions,
  member,
  mood,
  carpet,
  profileMember,
  app,
});

export default createStore(combinedReducers, compose(applyMiddleware(thunk)));
export { useDispatch, useSelector } from "react-redux";
